import styled, { css } from 'styled-components';
import { focusRing } from '@pleo-io/telescope-focus-ring';
import { red700, spacing12, borderPrimary, arc8, spacing8, shade700, shade000, fastInOut, shade600 } from '@pleo-io/telescope-tokens';

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

var disabledStyles = function disabledStyles(_ref) {
  var disabled = _ref.disabled,
      $isInvalid = _ref.$isInvalid;
  return !disabled && !$isInvalid && css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        :hover:not([aria-disabled='true']):not(:focus) {\n            border-color: ", ";\n        }\n    "])), shade600);
};

var sharedInputStyles = /*#__PURE__*/css(_templateObject2 || (_templateObject2 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    box-sizing: border-box;\n    width: 100%;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    color: ", ";\n    font-weight: inherit;\n    font-size: 14px;\n    font-family: inherit;\n    text-indent: 1px;\n    text-overflow: '';\n    background-color: ", ";\n    transition: ", ";\n    appearance: none;\n\n    ", "\n\n    ::placeholder,\n    option:disabled {\n        color: ", ";\n        font-style: italic;\n    }\n"])), spacing8, spacing8, shade700, shade000, fastInOut, disabledStyles, shade600);
var borderedInputStyles = /*#__PURE__*/css(_templateObject3 || (_templateObject3 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    padding: 0 ", ";\n    border: ", ";\n    border-radius: ", ";\n"])), sharedInputStyles, spacing12, borderPrimary, arc8);
var nakedInputStyles = /*#__PURE__*/css(_templateObject4 || (_templateObject4 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    ", ";\n    border: none;\n    border-bottom: ", ";\n"])), sharedInputStyles, borderPrimary);
var BaseInput = /*#__PURE__*/styled.input(_templateObject5 || (_templateObject5 = /*#__PURE__*/_taggedTemplateLiteralLoose(["\n    height: 40px;\n    ", "\n    ", "\n    ", "\n\n    ::-webkit-calendar-picker-indicator {\n        display: none;\n    }\n"])), function (_ref2) {
  var _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'bordered' : _ref2$variant;

  if (variant === 'bordered') {
    return borderedInputStyles;
  }

  if (variant === 'naked') {
    return nakedInputStyles;
  }

  return null;
}, focusRing, function (props) {
  return props.$isInvalid && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n            border-color: ", ";\n        "])), red700);
});
export { BaseInput };